import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GeneralService } from '@asambleas-services/general/general.service';
import { environment, NOTIFICATIONS_TYPES } from '@asambleas-env/environment';
import { Notification } from '@asambleas-models/notification.model';
import { UserFeedbackService } from '@asambleas-modules/user-feedback/user-feedback.service';
import { UserService } from '@asambleas-services/user/user.service';
import { User } from '@asambleas-models/user.model';

@Injectable()
export class NotificationsService {

    public notificacionWasRead: EventEmitter<boolean> = new EventEmitter();
    public pendingChurchesEvent: EventEmitter<boolean> = new EventEmitter();

    constructor(
        private http: HttpClient,
        private _generalService: GeneralService,
        private _userService: UserService,
        private _feedback: UserFeedbackService
    ) { }

    getNotifications() {
        return this.http.get(environment.apiEndPoint + '/notificaciones', this._generalService.getHeadersUser());
    }

    sendNotificationToAdmins(notification: Notification) {
        return this.http.post(environment.apiEndPoint + '/notificaciones/to-admins', notification, this._generalService.getHeadersUser());
    }

    notificacionRead(idNotification: number) {
        return this.http.post(environment.apiEndPoint + '/notificaciones/leida', { notification_id: idNotification }, this._generalService.getHeadersUser());
    }

    /**
     * Envia una notificación al director nacional para eleminar a un usuario
     *
     * @memberof NotificationsService
     */
    requestUserDelete(user: any) {
        let dialog = this._feedback.openDialog({
            type: 'confirm',
            title: 'Solicitud de Eliminación Usuario',
            body: 'Desea realizar una petición para la eliminación de este usuario. Presione "Aceptar" enviar la notificación.'
        })
        dialog.afterClosed().subscribe(resp => {
            if (resp) {
                const notificacion = new Notification()

                let currentUser: User
                let userToDelete = new User(user)

                this._userService.currentUser.subscribe(user => { currentUser = user })

                notificacion.$title = 'Solicitud de Eliminación (Usuario)';
                notificacion.$message = `${currentUser._fullname()} está solicitando la eliminación del usuario, "${userToDelete._fullname()}" de la plataforma`;

                notificacion.$data = {
                    type: NOTIFICATIONS_TYPES.DeleteUser,
                    requested_by: currentUser.serializeToNotification(),
                    user_data: userToDelete.serializeToNotification()
                }


                this.http.post(environment.apiEndPoint + '/notificaciones/request/delete', notificacion, this._generalService.getHeadersUser()).subscribe(resp => {
                    if (resp['success']) {
                        this._feedback.openSnackbar({ message: 'Tu solicitud ha sido enviada exitosamente' })
                    }
                })

            } else {
                this._feedback.openSnackbar({ message: 'La petición no será enviada' })
            }
        })
    }

    /**
     * Se envia una notificación para eliminar la iglesia
     *
     * @memberof NotificationsService
     */
    requestChurchDelete(church: any) {

        let dialog = this._feedback.openDialog({
            type: 'confirm',
            title: 'Solicitud de Eliminación Iglesia',
            body: 'Desea realizar una petición para la eliminación de esta iglesia. Presione "Aceptar" enviar la notificación.'
        })
        dialog.afterClosed().subscribe(resp => {
            if (resp) {
                const notificacion = new Notification()
                let currentUser: User

                this._userService.currentUser.subscribe(user => { currentUser = user })

                notificacion.$title = 'Solicitud de Eliminación (Iglesia)';
                notificacion.$message = `${currentUser._fullname()} está solicitando la eliminación de la iglesia, "${church.name}" de la plataforma`;

                notificacion.$data = {
                    type: NOTIFICATIONS_TYPES.DeleteChurch,
                    requested_by: currentUser.serializeToNotification(),
                    church_data: {
                        id: church.id,
                        name: church.name
                    }
                }

                this.http.post(environment.apiEndPoint + '/notificaciones/request/delete', notificacion, this._generalService.getHeadersUser()).subscribe(resp => {
                    if (resp['success']) {
                        this._feedback.openSnackbar({ message: 'Tu solicitud ha sido enviada exitosamente' })
                    }
                })

            } else {
                this._feedback.openSnackbar({ message: 'La petición no será enviada' })
            }
        })
    }

    processRequestNotification(n: Notification) {
        let title: string = '';
        let body: string = '';

        switch (n.data.type) {
            case NOTIFICATIONS_TYPES.DeleteChurch:
                title = 'Respuesta - Eliminar Iglesia';
                body = `${n.data.requested_by.name} ha solicitado la eliminación de la iglesia "${n.data.church_data.name}", ¿Deseas realmente eliminar los datos de esta iglesia?. Esta opción no se puede revertir.`;
                break;

            case NOTIFICATIONS_TYPES.DeleteUser:
                title = 'Respuesta - Eliminar Usuario';
                body = `${n.data.requested_by.name} ha solicitado la eliminación del usuario "${n.data.user_data.name}", ¿Deseas realmente eliminar los datos del usuario?. Esta opción no se puede revertir.`;
                break;
            default: break;
        }
        let dialog = this._feedback.openDialog({ 'type': 'confirm', 'title': title, 'body': body })
        dialog.afterClosed().subscribe(resp => {
            if (resp) {
                switch (n.data.type) {
                    case NOTIFICATIONS_TYPES.DeleteChurch:
                        this.http.delete(environment.apiEndPoint + '/iglesias/' + n.data.church_data.id, this._generalService.getHeadersUser()).subscribe((resp) => {
                            if (resp['success']) {
                                this._feedback.openSnackbar({ message: 'La solicitud fue llevada acabo, los datos han sido eliminados' });
                            }
                        }, error => {
                            this._feedback.openDialog({
                                body: error.error.message
                            }).afterClosed()
                        });
                        break;

                    case NOTIFICATIONS_TYPES.DeleteUser:
                        this.http.delete(environment.apiEndPoint + '/usuarios/' + n.data.user_data.id, this._generalService.getHeadersUser()).subscribe((resp) => {
                            if (resp['success']) {
                                this._feedback.openSnackbar({ message: 'La solicitud fue llevada acabo, los datos han sido eliminados' });
                            }
                        }, error => {
                            this._feedback.openDialog({
                                body: error.error.message
                            }).afterClosed()
                        });
                        break;

                    default: break;
                }

            } else {
                this._feedback.openSnackbar({ message: 'Ninguna acción será llevada acabo' })
            }
        })
    }

}



// WEBPACK FOOTER //
// ./src/app/services/notifications/notifications.service.ts